<template>
<div class="chapter">
<div class="inner_page">
<p class="ct_no_cn"><span epub:type="pagebreak" id="pagev" title="v"></span><a href="#/Text/Contents#Ded"><span class="blue">Dedication</span></a></p>
<p class="ded"><span epub:type="pagebreak" id="pagevi" title="vi"></span>For Saman Gunan, who sacrificed everything<br/>and<br/>Paul Gutman, for whom rescue was impossible</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?86903374